var _defs, _g, _path, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEvents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.632,4.199l0,10.696c0,0.738 -0.599,1.337 -1.337,1.337l-11.757,0c-0.738,0 -1.337,-0.599 -1.337,-1.337l0,-10.696c0,-0.738 0.599,-1.337 1.337,-1.337l11.757,0c0.738,0 1.337,0.599 1.337,1.337Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.715,3.225l0,2.905c0,0.2 -0.163,0.363 -0.363,0.363l-13.705,0c-0.2,0 -0.363,-0.163 -0.363,-0.363l0,-2.905c0,-0.2 0.163,-0.363 0.363,-0.363l13.705,0c0.2,0 0.363,0.163 0.363,0.363Z",
    fill: "#ffffff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.632,4.199l0,10.696c0,0.738 -0.599,1.337 -1.337,1.337l-11.757,0c-0.738,0 -1.337,-0.599 -1.337,-1.337l0,-10.696c0,-0.738 0.599,-1.337 1.337,-1.337l11.757,0c0.738,0 1.337,0.599 1.337,1.337Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.963,
    y: 11.941,
    width: 2.653,
    height: 2.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.174,
    y: 11.941,
    width: 2.653,
    height: 2.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.384,
    y: 11.941,
    width: 2.653,
    height: 2.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.963,
    y: 8.025,
    width: 2.653,
    height: 2.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.174,
    y: 8.025,
    width: 2.653,
    height: 2.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71,7.986l0.342,1.049l1.107,0l-0.895,0.649l0.342,1.049l-0.895,-0.649l-0.895,0.649l0.342,-1.049l-0.895,-0.649l1.107,-0l0.342,-1.049Z",
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.182,
    y: 1.129,
    width: 2.122,
    height: 3.466
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.355,
    y: 1.129,
    width: 2.122,
    height: 3.466
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.529,
    y: 1.129,
    width: 2.122,
    height: 3.466
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvents);
export default __webpack_public_path__ + "static/media/icon-Events.318f68973d94675b07c3b610a35c5266.svg";
export { ForwardRef as ReactComponent };